import { render, staticRenderFns } from "./App.vue?vue&type=template&id=33438c92&scoped=true&"
import script from "./App.vue?vue&type=script&lang=ts&"
export * from "./App.vue?vue&type=script&lang=ts&"
import style0 from "./App.vue?vue&type=style&index=0&id=33438c92&prod&scoped=true&lang=css&"
import style1 from "./App.vue?vue&type=style&index=1&id=33438c92&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33438c92",
  null
  
)

export default component.exports